ACC.breadcrumbs = {
  viewAllcatClass: 'ph-viewall-category',
  hiddenClass: 'hidden',
  breadcrumbId: '#breadcrumb',
  bcDropdownClass: '.ph-bc-dropdown',
  catBcClass: '.ph-category-breadcrumb > li',
  mobileBcClass: 'ph-mobile-bcitem',
  availableCls: 'ph-available',
  breadcrumbClass: '.ph-category-breadcrumb',

  displayBreadcrumbs: function() {
    var homeValue = $(ACC.breadcrumbs.breadcrumbId).find('.ph-breadcrumb_home').html();
    var newclass = '';
    var highlightBreadcrumbs = $('.highlightBreadcrumbs').html();

    if (highlightBreadcrumbs === 'true') {
      newclass = 'ph-highlight-breadcrumb-color';
    }

    var breadCrumbsHtml = '<ul class="ph-breadcrumb ph-category-breadcrumb ' + newclass + '">\n' +
    '<li class="ph-bchome"><a href="/">' + homeValue + '</a></li>\n' +
    '<li class="ph-catbreadcrumb-item ph-bcmobile ph-icon-arrow-down">\n' +
    '<span class="ph-bcmob_dots">...</span>&nbsp;<span class="ph-bc-dropdown hidden"><ul class="ph-breadcrumbs-dropdown"></ul></span></li></ul>';

    $(ACC.breadcrumbs.breadcrumbId).find('.ph-breadcrumb').addClass('ph-oldbreadcrumbs');
    $(ACC.breadcrumbs.breadcrumbId).append(breadCrumbsHtml).addClass('ph-breadcrumbs_wrapper');
    $(ACC.breadcrumbs.breadcrumbId).find('.ph-breadcrumb').hide();
    ACC.breadcrumbs.getBreadcrumbs('gr', 'ca');
    ACC.breadcrumbs.getBreadcrumbs('ca', 'su');
    ACC.breadcrumbs.getBreadcrumbs('su', '');
    $(document).on('click', ACC.breadcrumbs.catBcClass, function() {
      if ($(this).children(ACC.breadcrumbs.bcDropdownClass).hasClass(ACC.breadcrumbs.hiddenClass)) {
        $(ACC.breadcrumbs.catBcClass).children(ACC.breadcrumbs.bcDropdownClass).addClass(ACC.breadcrumbs.hiddenClass);
        $(this).children(ACC.breadcrumbs.bcDropdownClass).removeClass(ACC.breadcrumbs.hiddenClass);
      } else {
        $(ACC.breadcrumbs.catBcClass).children(ACC.breadcrumbs.bcDropdownClass).addClass(ACC.breadcrumbs.hiddenClass);
      }
    });

    $(ACC.breadcrumbs.breadcrumbId).find(ACC.breadcrumbs.breadcrumbClass).addClass('ph-visible');

    $(document).on('click', 'body,html', function(e) {
      if ($(e.target).closest(ACC.breadcrumbs.bcDropdownClass).length === 0 && $(e.target).closest('.ph-catbreadcrumb-item').length === 0) {
        $(ACC.breadcrumbs.catBcClass).children(ACC.breadcrumbs.bcDropdownClass).addClass(ACC.breadcrumbs.hiddenClass);
      }
    });
    ACC.breadcrumbs.mobileDropdown();
  },
  checkActiveCategory: function($currentNode, level) {
    var isActive = '';

    if (level === 'gr') {
      isActive = ACC.topnavigation.activeClassGr($currentNode);

      if (isActive !== '') {
        $(ACC.breadcrumbs.breadcrumbId).find('.ph-bclevel-gr').addClass('ph-available ph-mobile-bcitem');
      }
    } else {
      var identifier = $currentNode.children('a').attr('data-identifier');

      isActive = ACC.topnavigation.activeClassSublevel(identifier);
    }

    return isActive;
  },
  getBreadcrumbs: function(level, nextLevel) {
    var bcData = '',
        nodeActive = '';

    $(ACC.breadcrumbs.breadcrumbId).find(ACC.breadcrumbs.breadcrumbClass).append('<li class="ph-catbreadcrumb-item ph-bclevel-' + level + '"></li>');
    $('.ph-subnavigation').find('.ph-menulevel-' + level + ' > li').each(function() {
      var $currentNode = $(this);

      if (ACC.breadcrumbs.checkActiveCategory($currentNode, level) !== '') {
        nodeActive = $currentNode;

        var dropdowncontent = ACC.breadcrumbs.getBcDropdown($currentNode, nextLevel);

        bcData = ACC.breadcrumbs.generateBcData($currentNode, dropdowncontent);
      }
    });

    if (bcData !== '' && level !== 'gr') {
      $(ACC.breadcrumbs.catBcClass).removeClass(ACC.breadcrumbs.mobileBcClass);
      $(ACC.breadcrumbs.breadcrumbId).find('.ph-bcmobile').addClass(ACC.breadcrumbs.mobileBcClass);
    }

    if (bcData !== '') {
      $(ACC.breadcrumbs.breadcrumbId).find('.ph-bclevel-' + level).addClass(' ph-mobile-bcitem ph-available');
    }

    $('.ph-bclevel-' + level).html(bcData);
    ACC.breadcrumbs.populatreCaFromSu(nodeActive, level);
  },
  populatreCaFromSu: function(nodeActive, level) {
    if (level === 'su' && nodeActive !== '') {
      var $currentNode = nodeActive.closest('.ph-menuitem-ca'),
          dropdowncontent = ACC.breadcrumbs.getBcDropdown($currentNode, level),
          bcData = ACC.breadcrumbs.generateBcData($currentNode, dropdowncontent);

      if (bcData !== '') {
        $(ACC.breadcrumbs.breadcrumbId).find('.ph-bclevel-ca').addClass(ACC.breadcrumbs.availableCls);
      }

      $('.ph-bclevel-ca').html(bcData);
    }
  },
  generateBcData: function($currentNode, dropdowncontent) {
    var bcData = '',
        dropdowncontentTemp = '';

    if (dropdowncontent === '') {
      bcData = '<a href="' + $currentNode.children('a').attr('href') + '">\n' +
          '<span>' + $currentNode.children('a').text() + '</span></a>';

      if ($currentNode.hasClass(ACC.breadcrumbs.viewAllcatClass)) {
        bcData = '';
      }
    } else {
      bcData = '<a class="ph-inactive-link ph-icon-arrow-down" href="' + $currentNode.children('a').attr('href') + '">\n' +
          '<span>' + $currentNode.children('a').text() + '</span></a>';
      dropdowncontentTemp = '<span class="ph-bc-dropdown hidden">\n' +
          '<ul class="ph-breadcrumbs-dropdown"><li class="ph-bcheading">' + bcData + '</li>' + dropdowncontent + '</ul></span>';
    }

    bcData = bcData + dropdowncontentTemp;

    return bcData;
  },
  getBcDropdown: function($currentNode, level) {
    var breadCrumbsHtml = '',
        menulevelClass = 'ph-menulevel-' + level;

    if ($currentNode !== '' && level !== '' && $currentNode.find('.' + menulevelClass).length > 0) {
      $currentNode.find('.' + menulevelClass + ' > li').each(function() {
        var viewAllCatClass = '',
            activeClass = '',
            thirdLevelActiveItem = $(this).find('.ph-slideright-navigation > .ph-currently-active');

        if ($(this).hasClass(ACC.breadcrumbs.viewAllcatClass)) {
          viewAllCatClass = ACC.breadcrumbs.viewAllcatClass;
        }


        if ($(this).hasClass('ph-currently-active') || thirdLevelActiveItem.length > 0) {
          activeClass = ' ph-activated';
        }

        breadCrumbsHtml = breadCrumbsHtml + '<li class="' + viewAllCatClass + activeClass + '">\n' +
        '<a href="' + $(this).children('a').attr('href') + '">' + $(this).children('a').text() + '</a></li>';
      });
    }

    return breadCrumbsHtml;
  },
  mobileDropdown: function() {
    $(document).on('click', '.ph-bcmobile', function() {
      var $mobileDotNode = $(this),
          dropdownHtml = '',
          activeMobileLevel = '';

      if ($mobileDotNode.next().hasClass(ACC.breadcrumbs.availableCls)) {
        dropdownHtml = dropdownHtml + '<li class="ph-mobbclevels ph-mobbclevel-gr">' + $mobileDotNode.next().children('a').html() + '</li>';
        activeMobileLevel = 'gr';
      }

      if ($mobileDotNode.next().next().hasClass(ACC.breadcrumbs.availableCls)) {
        dropdownHtml = dropdownHtml + '<li class="ph-mobbclevels ph-mobbclevel-ca">' + $mobileDotNode.next().next().children('a').html() + '</li>';
        activeMobileLevel = 'ca';
      }

      $mobileDotNode.find('.ph-breadcrumbs-dropdown').html(dropdownHtml);
      $('.ph-mobbclevels > span').removeClass('ph-activebold ph-icon-arrow-right');
      $('.ph-mobbclevel-' + activeMobileLevel + ' > span').addClass('ph-activebold ph-icon-arrow-right');
    });
    ACC.breadcrumbs.toggleMobMenu('gr');
    ACC.breadcrumbs.toggleMobMenu('ca');
  },
  toggleMobMenu: function(level) {
    $(document).on('click', '.ph-mobbclevel-' + level, function() {
      $('.ph-catbreadcrumb-item.ph-available').removeClass(ACC.breadcrumbs.mobileBcClass);
      $('.ph-catbreadcrumb-item.ph-bclevel-' + level).addClass(ACC.breadcrumbs.mobileBcClass);

      if (level === '-gr') {
        $('.ph-catbreadcrumb-item.ph-bcmobile').removeClass(ACC.breadcrumbs.mobileBcClass);
      }
    });
  }
};
